module.exports = __webpack_public_path__ + "static/media/aberdeen.2b50dc77.png";